import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/core/application/security/useAuthStore';

interface SecretaryGuardProps {
  children: React.ReactNode;
}

export function SecretaryGuard({ children }: Readonly<SecretaryGuardProps>) {
  const { isSecretaria, isInitialized, isFetchingFallback } = useAuthStore();
  const location = useLocation();

  // Esperar hasta que la sesión esté inicializada Y los roles (fallback RPC) cargados
  if (!isInitialized || isFetchingFallback) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-950">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-700 border-t-white"></div>
      </div>
    );
  }

  // Si no es secretaria asignada, denegar acceso.
  if (!isSecretaria) {
    return <Navigate to="/hub" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
